"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinearGradient = LinearGradient;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------
const DEFAULT_COLORS = ['blue500', 'blue900'];

/**
 * `LinearGradient` provides box with a background that transitions between multiple colors in a linear direction.
 */
function LinearGradient({
  children,
  colors: [start, end] = DEFAULT_COLORS,
  css,
  testId
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.BaseContainer, {
    css: css,
    "data-testid": testId,
    end: end,
    start: start
  }, children);
}